import { render } from "./DetalleTableroControl.vue?vue&type=template&id=04a77ed0&scoped=true"
import script from "./DetalleTableroControl.vue?vue&type=script&lang=js"
export * from "./DetalleTableroControl.vue?vue&type=script&lang=js"

import "./DetalleTableroControl.vue?vue&type=style&index=0&id=04a77ed0&scoped=true&lang=css"

import exportComponent from "C:\\AgentesAzure\\SVRAPQAHIR01\\vsts-agent-win-x64-4.261.0\\_work\\31\\s\\CCD\\hircasa-ccd-webapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a77ed0"]])

export default __exports__